import { lazy } from 'react';
import withSuspense from 'utils/withSuspense';
const ContactFormProduct = lazy(() => import('features/contact-form/components/ProductById'));

const ContactFormProductRoute = withSuspense(ContactFormProduct);

export default ContactFormProductRoute;
